<template src='./auditLog.pug' lang='pug'></template>

<script>
import MultiSelectModal from '../../../modals/multiSelectModal/MultiSelectModal'
import AuditModal from '../../../administration/auditLog/AuditModal'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import FormSearch from '../../../form/formSearch/FormSearch'
import DateRange from '../../../input/dateRange/DateRange'
import BetterInputTag from '../../../input/betterInputTag/BetterInputTag'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import TreeGrid from '../../../treeGrid/TreeGrid'
import axios from '../../../../../build/http-requests/axios-common.js'
import { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'
import { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'

export default {
  name: 'AuditLog',

  components: {
    MultiSelectModal,
    AuditModal,
    PageTitle,
    FilterPortlet,
    FormSearch,
    DateRange,
    BetterInputTag,
    ButtonPrimary,
    TreeGrid
  },

  data () {
    return {
      gridId: '#auditLogGrid',
      isAdvancedSearch: true,
      OPERATORS_MODAL: 'operatorsModal',
      ENTITIES_MODAL: 'entitiesModal',
      FUNCTIONALITIES_MODAL: 'functionalitiesModal',
      audit: {},
      dateRange: {},
      list: [],
      selectedList: [],
      selectModal: null,
      allItensSelected: null,
      operatorsSelected: [],
      operatorsTags: [this.$t('inputTag.labels.todos')],
      functionalitiesSelected: [],
      functionalitiesTags: [this.$t('inputTag.labels.todos')],
      entitiesSelected: [],
      entitiesTags: [this.$t('inputTag.labels.todos')],
      customId: 'id',
      firstDate: new Date(),
      finalDate: new Date(),
      showTreegrid: false,
      exportUrl: EXPORT_TREEGRID,
      filter: {
        entityId: null
      },
      result: {},
      treeGridFileName: 'LogDeAuditoria',
      dataTableColumns: [],
      disableSearchButton: false,
      firstTimeOp: true,
      firstTimeFunc: true,
      firstTimeEnt: true,
      titleModal: null,
      subTitleModal: null,
      columnsClasses: {},
      orderBy: {},
      headings: {},
      templates: {},
      customSorting: {},
      sortable: [],
      selectDataTableCustomSetOrder: null,
      customTagMap: null,
      rowId: null,
      filterable: ['nome', 'email', 'nomeFuncionalidade', 'numeroEntidade', 'descricao'],
      data: this.setDataValues(),
      inputTagsProps: {
        operators: {
          id: 'id',
          name: 'nome'
        },
        functionalities: {
          id: 'idFuncionalidade',
          name: 'nomeFuncionalidade'
        },
        entities: {
          id: 'numeroEntidade',
          name: 'numeroEntidade'
        }
      },
      shown: {
        operators: false,
        functionalities: false,
        entities: false
      },
      defaultTags: {
        operators: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todos')
        }],
        functionalities: [{
          idFuncionalidade: '-1',
          nomeFuncionalidade: this.$t('inputTag.labels.todos')
        }],
        entities: [{
          numeroEntidade: this.$t('inputTag.labels.todos'),
          descricao: this.$t('inputTag.labels.todos')
        }]
      }
    }
  },

  methods: {
    setDataValues () {
      const data = {
        operators: this.setOperatorsData(),
        functionalities: this.setFunctionalitiesData(),
        entities: this.setEntitiesData()
      }
      return data
    },

    setEntitiesData () {
      return {
        titles: {
          main: this.$t('logDeAuditoria.labels.entidades'),
          sub: this.$t('logDeAuditoria.labels.selecionarEntidades')
        },
        selectedItems: [],
        columns: ['numeroEntidade', 'descricao'],
        values: [],
        options: {
          columnsClasses: { numeroEntidade: 'col-md-4', descricao: 'col-md-8' },
          perPage: 5,
          headings: {
            numeroEntidade: this.$t('logDeAuditoria.labels.entidade'),
            descricao: this.$t('logDeAuditoria.labels.descricao')
          },
          filterable: ['numeroEntidade', 'descricao'],
          filterByColumn: true,
          perPageValues: [],
          texts: {
            count: this.$t('dataTable.labels.contagem'),
            noResults: this.$t('dataTable.labels.semResultados'),
            filterBy: '',
            filterPlaceholder: this.$t('dataTable.labels.filtrar')
          },
          sortable: ['numeroEntidade', 'descricao'],
          sortIcon: {
            is: ''
          },
          pagination: { chunk: 5 },
          orderBy: {
            ascending: true,
            column: 'numeroEntidade'
          },
          customSorting: {
            numeroEntidade: (asc) => {
              return (a, b) => {
                if (asc) {
                  return a.numeroEntidade.toLowerCase().localeCompare(b.numeroEntidade.toLowerCase())
                }
                return b.numeroEntidade.toLowerCase().localeCompare(a.numeroEntidade.toLowerCase())
              }
            },
            descricao: function (asc) {
              return function (a, b) {
                if (asc) {
                  return a.descricao.toLowerCase().localeCompare(b.descricao.toLowerCase())
                }
                return b.descricao.toLowerCase().localeCompare(a.descricao.toLowerCase())
              }
            }
          }
        }
      }
    },

    setOperatorsData () {
      return {
        titles: {
          main: this.$t('logDeAuditoria.labels.operadores'),
          sub: this.$t('logDeAuditoria.labels.selecionarOperador')
        },
        selectedItems: [],
        columns: ['nome', 'email'],
        values: [],
        options: {
          columnsClasses: { nome: 'col-md-7', email: 'col-md-5' },
          perPage: 5,
          headings: {
            nome: this.$t('administracao.operadores.labels.nome'),
            email: this.$t('administracao.operadores.labels.email')
          },
          filterable: ['nome', 'email'],
          filterByColumn: true,
          perPageValues: [],
          texts: {
            count: this.$t('dataTable.labels.contagem'),
            noResults: this.$t('dataTable.labels.semResultados'),
            filterBy: '',
            filterPlaceholder: this.$t('dataTable.labels.filtrar')
          },
          sortable: ['nome', 'email'],
          sortIcon: {
            is: ''
          },
          pagination: { chunk: 5 },
          orderBy: {
            ascending: true,
            column: 'nome'
          },
          customSorting: {
            nome: (asc) => {
              return (a, b) => {
                if (asc) {
                  return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase())
                }
                return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase())
              }
            },
            email: function (asc) {
              return function (a, b) {
                if (asc) {
                  return a.email.toLowerCase().localeCompare(b.email.toLowerCase())
                }
                return b.email.toLowerCase().localeCompare(a.email.toLowerCase())
              }
            }
          }
        }
      }
    },

    setFunctionalitiesData () {
      return {
        titles: {
          main: this.$t('logDeAuditoria.labels.funcionalidades'),
          sub: this.$t('logDeAuditoria.labels.selecionarFuncionalidades')
        },
        selectedItems: [],
        columns: ['nomeFuncionalidade', 'nomeGrupoFuncionalidade'],
        values: [],
        options: {
          columnsClasses: { nomeFuncionalidade: 'col-md-7', grupoFuncionalidade: 'col-md-5' },
          perPage: 5,
          headings: {
            nomeFuncionalidade: this.$t('administracao.operadores.labels.nome'),
            nomeGrupoFuncionalidade: this.$t('administracao.perfilAcesso.labels.grupoFuncionalidade')
          },
          filterable: ['nomeFuncionalidade', 'nomeGrupoFuncionalidade'],
          filterByColumn: true,
          perPageValues: [],
          texts: {
            count: this.$t('dataTable.labels.contagem'),
            noResults: this.$t('dataTable.labels.semResultados'),
            filterBy: '',
            filterPlaceholder: this.$t('dataTable.labels.filtrar')
          },
          sortable: ['nomeFuncionalidade', 'nomeGrupoFuncionalidade'],
          sortIcon: {
            is: ''
          },
          pagination: { chunk: 5 },
          orderBy: {
            ascending: true,
            column: 'nomeGrupoFuncionalidade'
          },
          customSorting: {
            nomeFuncionalidade: (asc) => {
              return (a, b) => {
                if (asc) {
                  return a.nomeFuncionalidade.toLowerCase().localeCompare(b.nomeFuncionalidade.toLowerCase())
                }
                return b.nomeFuncionalidade.toLowerCase().localeCompare(a.nomeFuncionalidade.toLowerCase())
              }
            }
          }
        }
      }
    },

    validate () {
      const self = this
      return new Promise(resolve => {
        this.$validator.validateAll()
          .then((result) => {
            if (result && this.$refs.dateRange.validate()) {
              this.showTreegrid = true
              startTreeGridLoading(self.gridId)
              this.search().finally(() => {
                resolve()
              })
            } else {
              resolve()
            }
          })
      })
    },

    resetFilter () {
      this.filter.entityId = null
      this.data.operators.selectedItems = []
      this.data.functionalities.selectedItems = []
      this.data.entities.selectedItems = []
    },

    search () {
      this.disableSearchButton = true
      let inicio = this.dateRange.fromDate
      let fim = this.dateRange.toDate

      let filter = {
        inicio: inicio,
        fim: fim,
        idEntidadeDoSistema: this.filter.entityId,
        idsOperadores: this.data.operators.selectedItems.map(selected => selected.id).filter(operator => operator !== '-1'),
        idsFuncionalidades: this.data.functionalities.selectedItems.map(selected => selected.idFuncionalidade).filter(functionality => functionality !== '-1'),
        idsEntidades: this.data.entities.selectedItems.map(selected => selected.numeroEntidade).filter(entity => entity !== this.$t('inputTag.labels.todos'))
      }

      return new Promise((resolve, reject) => {
        axios.post('/auditLog/audits', { filter: filter })
          .then((response) => {
            window.DisposeGrids()
            this.result = response.data
            window.Grids.abrirModalAuditoria = (row) => {
              this.$store.dispatch('getAudit', row.Id)
                .then((response) => {
                  this.audit = response.data
                  $('#auditModal').modal()
                })
            }
            stopTreeGridLoading(this.gridId)
            this.disableSearchButton = false
            resolve()
          })
          .catch((error) => {
            this.$root.$refs.notification.error(error)
            stopTreeGridLoading(this.gridId)
            this.disableSearchButton = false
            reject()
          })
      })
    },

    openSelectOperatorsModal () {
      if (this.data.operators.values.length > 0) {
        this.shown.operators = true
        return
      }
      this.$store.dispatch('getOperators', '/auditLog/operator').then((response) => {
        this.data.operators.values = response.data
        this.shown.operators = true
      })
    },

    openSelectFunctionalitiesModal () {
      if (this.data.functionalities.values.length > 0) {
        this.shown.functionalities = true
        return
      }
      this.$store.dispatch('getFunctionalitiesGroups', '/auditLog/functionalitiesGroups').then((response) => {
        this.data.functionalities.values = response.data.map(gf => {
          gf.funcionalidades.forEach(f => {
            f.idFuncionalidade = f.id
            f.nomeFuncionalidade = f.nome
            f.nomeGrupoFuncionalidade = gf.nome
          })
          return gf.funcionalidades
        }).flat()
        this.shown.functionalities = true
      })
    },

    openSelectEntitiesModal () {
      if (this.data.entities.values.length > 0) {
        this.shown.entities = true
        return
      }
      this.$store.dispatch('getEntities').then((response) => {
        this.data.entities.values = response.data.data.map(entity => {
          if (entity.numeroEntidade === 'AtributoConfig') {
            entity.numeroEntidade = 'Atributo'
          }
          return entity
        })
        this.shown.entities = true
      })
    },

    openModal () {
      $('#selectModal').modal({ backdrop: 'static', keyboard: false })
    },

    closeModal () {
      this.shown.operators = false
      this.shown.functionalities = false
      this.shown.entities = false
    }
  }
}
</script>

<style lang='css' scoped>
.input-button>button {
  margin: 24px 0 0 0;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  height: 36px;
  float: left;
}

#logDeAuditoriaWrapper {
  width: 100%;
}

#divTreeGridAuditoria {
  min-width: 100%;
  min-height: 500px;
}

.check {
  text-align: center;
}

.filterButton {
  width: 3vw;
  margin: 0px !important;
}

.col-search {
  width: 53.5%;
}

.search-button {
  min-width: 7vw;
}
</style>



// WEBPACK FOOTER //
// AuditLog.vue?30f2d548